import * as React from "react";
import { useRouter } from "next/router";
import { useProductId } from "../../hooks/use-product-attributes";
import { getRecentlyViewedProducts } from "@lululemon/ecom-common/src/lib/tile-utils";
import { RecentlyViewedCarousel } from "@lululemon/pdp-components";

const { useEffect, useState } = React;

const MIN_RECORDS_LENGTH = 2;

const RecentlyViewedCarouselAdapter = () => {
  const [data, setData] = useState([]);
  const productId = useProductId();
  const { locale } = useRouter();

  useEffect(() => {
    setData(getRecentlyViewedProducts(productId, locale));
  }, [productId, locale]);

  const shouldRender = data?.length >= MIN_RECORDS_LENGTH;

  if (!shouldRender) {
    return null;
  }

  return <RecentlyViewedCarousel data={data} />;
};

export default RecentlyViewedCarouselAdapter;
